import {Types} from "../../../../type/Types";

export type PlacePathBrowserValueObject = {
    id: bigint
    placePathId: bigint | null
    osType: string
    browser: string
    weight: number
    createdAt: Date
    modifiedAt: Date | null
    deletedAt: Date | null
}

export namespace PlacePathBrowserValueObject {
    export function construct(o: any): PlacePathBrowserValueObject {
        return {
            id: BigInt(o.id),
            placePathId: BigInt(o.placePathId),
            osType: String(o.osType),
            browser: String(o.browser),
            weight: Number(o.weight),
            createdAt: new Date(o.createdAt),
            modifiedAt: Types.asNull(o.modifiedAt, o => new Date(o)),
            deletedAt: Types.asNull(o.deletedAt, o => new Date(o)),
        }
    }

    export const description: Record<keyof PlacePathBrowserValueObject, string> = {
        id: 'ID',
        placePathId: '플레이스 경로 ID',
        osType: '운영체제',
        browser: '브라우저',
        weight: '가중치',
        createdAt: '생성 시각',
        modifiedAt: '수정 시각',
        deletedAt: '삭제 시각',
    }
}